var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBuk(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 159,
    height: 60,
    viewBox: "0 0 159 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1232_5270)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17.3061 0H24.8603V38.8736C24.8603 43.322 25.9945 46.7753 28.2572 49.2247C30.5241 51.6785 33.6439 52.9032 37.618 52.9032C41.5921 52.9032 45.0034 51.7075 47.3569 49.309C49.7061 46.9133 50.8793 43.4354 50.8793 38.8736C50.8793 34.3119 49.6095 31.1128 47.064 28.6082C44.5156 26.0978 41.1721 24.8397 37.0264 24.8397C33.5025 24.8397 30.452 25.8581 27.8777 27.8877V20.2823C30.9542 18.5898 34.2875 17.7458 37.8676 17.7458C43.7941 17.7458 48.7105 19.6765 52.6008 23.5351C56.4912 27.3937 58.4349 32.5061 58.4349 38.8722C58.4349 45.5782 56.4017 50.7777 52.3497 54.462C48.2862 58.155 43.1837 59.9986 37.0264 59.9986C30.869 59.9986 26.3913 58.0823 22.7607 54.2557C19.1214 50.4218 17.3047 45.292 17.3047 38.8722V0H17.3061Z",
    fill: "#2F4DAA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M101.275 59.7406H86.6138C80.3381 59.7406 75.846 58.8006 73.1346 56.9236C70.7031 55.2732 69.1619 53.2931 68.5111 50.989C67.8647 48.6878 67.5371 45.6587 67.5371 41.9033V18.7793H74.9975V41.819C74.9975 42.8403 75.0235 43.7076 75.0812 44.4209C75.1389 45.1343 75.3352 46.0422 75.6743 47.1536C76.0148 48.2621 76.4953 49.1701 77.1173 49.8834C77.7349 50.5938 78.6397 51.2185 79.8316 51.7604C81.0163 52.3023 82.455 52.5696 84.1534 52.5696H93.8173V18.7793H101.275V59.7406Z",
    fill: "#2F4DAA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M133.503 18.7743H141.724L131.464 36.6116C132.929 37.1666 134.711 38.076 136.407 39.6044C141.952 44.6063 141.931 52.0707 141.895 53.5947V59.7341H134.433V53.5061C134.433 49.6939 133.317 46.7521 131.086 44.6731C128.851 42.5985 125.675 41.5598 121.549 41.5598C120.252 41.5598 118.922 41.6441 117.562 41.8155V59.7327H110.109V0H117.562V35.0789C119.943 34.7346 122.313 34.7346 124.685 35.0789L133.502 18.7743H133.503Z",
    fill: "#2F4DAA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.20642 32.0717C8.20642 34.3511 6.36658 36.1991 4.10682 36.1991C1.84706 36.1991 0 34.3511 0 32.0717C0 29.7923 1.83984 27.9443 4.10682 27.9443C6.3738 27.9443 8.20642 29.7923 8.20642 32.0717Z",
    fill: "#2F4DAA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M159 32.0717C159 34.3511 157.165 36.1991 154.896 36.1991C152.628 36.1991 150.797 34.3511 150.797 32.0717C150.797 29.7923 152.635 27.9443 154.896 27.9443C157.158 27.9443 159 29.7923 159 32.0717Z",
    fill: "#2F4DAA"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1232_5270"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 159,
    height: 60,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBuk);
export default __webpack_public_path__ + "static/media/buk.69d1587a2f897477ca03c77b7047d8b7.svg";
export { ForwardRef as ReactComponent };